import { QueryCache, QueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { normalizeError } from './api';
import type { ApiError } from '@/types/api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        const err = error as unknown as ApiError;
        if (err?.status === 401 || err?.status === 403 || err?.status === 404) {
          return false;
        }
        return failureCount < 2;
      },
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: (error) => {
        const err = error as unknown as ApiError | undefined;
        if (!err) return;
        // 401 is handled silently by the axios interceptor (refresh-and-retry).
        if (err.status === 401) return;
        toast.error(err.message);
      },
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      const err = error as unknown as ApiError;
      if (err?.status >= 500) {
        toast.error(err.message);
      }
    },
  }),
});

export { normalizeError };
